"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const MapTooltipRecommendationSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipRecommendationSection.vue"));
const MapTooltipMetricSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipMetricSection.vue"));
let MapTooltip = class MapTooltip extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mainSectionEnablers = ['recommendations', 'need-maps', 'metrics'];
    }
    mainActionClicked() {
        this.$emit('mainActionClicked');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: new Recommendations_1.FieldRecommendation({}, []) })
], MapTooltip.prototype, "field", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapTooltip.prototype, "mapSideBarPanel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapTooltip.prototype, "cleanModal", void 0);
MapTooltip = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            Tag: bmk_ui_framework_1.Tag,
            MapTooltipRecommendationSection: MapTooltipRecommendationSection_vue_1.default,
            MapTooltipMetricSection: MapTooltipMetricSection_vue_1.default
        },
    })
], MapTooltip);
exports.default = MapTooltip;
